import clsx from 'clsx'
import React from 'react'
import { Control } from 'react-hook-form'
import { FormattedMessage } from 'react-intl'

import s from './styles.module.scss'

import SelectProposalMenuItem from './select-proposal-menu-item/SelectProposalMenuItem'
import { ISelectProposalForm } from '../modal-select-proposal.types'
import {
  getHouseExtrasMenus,
  getHouseRegularMenus,
} from '../utils/modal-select-proposal.utils'
import { ClientPricingMenuOutputDto } from '../../../../lib/graphql'
import { calcNights } from '../../../../utils'

export interface FormClientPricingMenusOutputDtoRecord {
  [key: string]: ClientPricingMenuOutputDto
}

const ModalSelectProposalMenus = ({
  formValues,
  control,
  type,
  isLowRes = false,
  handleQuantityError,
}: {
  formValues: ISelectProposalForm
  handleQuantityError?: (key: string, message: string | null) => void
  control: Control<ISelectProposalForm, any>
  type: 'REGULAR' | 'EXTRA'
  isLowRes?: boolean
}) => {
  if (!formValues.dates.startDate || !formValues.dates.endDate) {
    return null
  }

  const numberOfNights = calcNights(
    formValues.dates.startDate,
    formValues.dates.endDate,
  )

  const getMenusToDisplay = () => {
    if (type === 'REGULAR') {
      return getHouseRegularMenus({ formValues })
    } else {
      return getHouseExtrasMenus({ formValues })
    }
  }

  return (
    <div className={s.container} style={{ padding: isLowRes ? '0' : '' }}>
      <div className={clsx(s.menuItem, s.menuHeader)}>
        <div className={s.menuItemIntro}>
          <div className={s.menuItemTitle}>
            <FormattedMessage id='ui.proposal-modal.formulaType' />
          </div>
        </div>
        <div className={s.menuItemElements}>
          <FormattedMessage
            id='ui.proposal-modal-services'
            defaultMessage='Prestations'
            values={{}}
          />
        </div>
        <div className={s.menuItemPrice}>
          <div className={s.containerNumberOfNights}>
            <FormattedMessage
              id='ui.proposal-modal.priceForXNights'
              defaultMessage='Tarif pour {numberOfNights, plural, one {une nuit} other {# nuits}}'
              values={{ numberOfNights }}
            />
          </div>
        </div>
        <div className={s.menuItemQuantity}>
          <FormattedMessage
            id='ui.proposal-modal.pickANumber'
            defaultMessage='Sélectionnez un nombre'
          />
        </div>
      </div>
      <div className={s.content}>
        {getMenusToDisplay().map((menu) => (
          <SelectProposalMenuItem
            control={control}
            key={menu._id}
            menu={menu}
            formValues={formValues}
            handleQuantityError={handleQuantityError}
          />
        ))}
      </div>
    </div>
  )
}

export default ModalSelectProposalMenus
